export const clearLocalStorage = () => {
  localStorage.removeItem("isExpandableMenu")
  localStorage.removeItem("menus")
  localStorage.removeItem("userInformation")
  sessionStorage.removeItem("dataUpload")
}
